import React from "react";
import { Box } from "@mui/material";
import Form from "./form";
import { customerservice } from "../../../../config";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
const base_url = customerservice.uri;

const CustomerSettings = () => {
  const actions = {
      // entity: localStorage.getItem("SelectedTabLabel"),
      entity:"CustomerSettings",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    dataObject: {
      ignoreFields: ["UpdateDate", "CreateDate"],
      objectName: "customerSettings",
      parameters: "",
    },
    showStatus: true,
  };

  return (
    <Box m="20px">
      <DynamicTableForJson
        title="CustomerSettings Management"
        subtitle="Manage Customer Settings"
        FormComponent={Form}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
};

export default CustomerSettings;
